(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  class HeroCrossfade extends HTMLElement {
    connectedCallback() {
      const templates = Array.from(this.querySelectorAll('template.hero-slide-template'));
      const slidesContainer = this.querySelector('.hero-slideshow__slides');

      if (!slidesContainer || templates.length === 0) return;

      this.slides = templates.map((template, i) => {
        const slide = document.createElement('div');
        slide.className = 'hero-slideshow__slide' + (i === 0 ? ' hero-slideshow__slide--active' : '');

        // Copy shopify block attributes so theme editor can highlight the block
        Array.from(template.attributes).forEach(attr => {
          if (attr.name.startsWith('data-shopify')) {
            slide.setAttribute(attr.name, attr.value);
          }
        });

        // Set first image to eager load
        const img = template.content.querySelector('img');
        if (img && i === 0) {
          img.loading = 'eager';
          img.fetchPriority = 'high';
        }

        slide.appendChild(template.content.cloneNode(true));
        slidesContainer.appendChild(slide);
        return slide;
      });

      if (this.slides.length <= 1) return;

      this.current = 0;
      this.speed = parseInt(this.dataset.speed) || 7000;

      this.timer = setTimeout(() => {
        this.advance();
        this.interval = setInterval(() => this.advance(), this.speed);
      }, this.speed);
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      clearInterval(this.interval);
    }

    advance() {
      this.slides[this.current].classList.remove('hero-slideshow__slide--active');
      this.current = (this.current + 1) % this.slides.length;
      this.slides[this.current].classList.add('hero-slideshow__slide--active');
    }
  }

  if (!customElements.get('hero-crossfade')) {
    customElements.define('hero-crossfade', HeroCrossfade);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  // Sync the Afterpay On-Site Messaging app block when the variant changes.
  // App blocks are excluded from Shopify's section render API, so the placement
  // element is never replaced — we just update data-amount on the existing element.
  // Afterpay (now Square) renders as <square-placement data-amount="...">.
  // The custom element responds to attribute changes on its own.
  document.addEventListener('variant:update', function (event) {
    const price = event.detail?.resource?.price;
    if (price == null) return;

    // Shopify prices are in cents; Afterpay data-amount is a decimal string
    const amount = (price / 100).toFixed(2);

    // Defer so Afterpay's synchronous re-render doesn't block the price update
    // from painting. The price updates in the current frame; Afterpay updates next.
    setTimeout(function () {
      document.querySelectorAll('square-placement').forEach(function (el) {
        el.setAttribute('data-amount', amount);
      });
    }, 0);
  });

  } catch(e) { console.error(e); }
})();
})();
